/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitLogoDetail,
    PressKitLogoDetailFromJSON,
    PressKitLogoDetailFromJSONTyped,
    PressKitLogoDetailToJSON,
} from './PressKitLogoDetail';

/**
 * 
 * @export
 * @interface GetPressKitLogoDetailResponse
 */
export interface GetPressKitLogoDetailResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetPressKitLogoDetailResponse
     */
    status: number;
    /**
     * ステータスメッセージ。原則英語。
     * @type {string}
     * @memberof GetPressKitLogoDetailResponse
     */
    message: string;
    /**
     * 
     * @type {PressKitLogoDetail}
     * @memberof GetPressKitLogoDetailResponse
     */
    data: PressKitLogoDetail;
}

export function GetPressKitLogoDetailResponseFromJSON(json: any): GetPressKitLogoDetailResponse {
    return GetPressKitLogoDetailResponseFromJSONTyped(json, false);
}

export function GetPressKitLogoDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressKitLogoDetailResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressKitLogoDetailFromJSON(json['data']),
    };
}

export function GetPressKitLogoDetailResponseToJSON(value?: GetPressKitLogoDetailResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressKitLogoDetailToJSON(value.data),
    };
}

